import { render, staticRenderFns } from "./email-client-figure.vue?vue&type=template&id=4d5847c0&scoped=true&"
import script from "./email-client-figure.vue?vue&type=script&lang=ts&"
export * from "./email-client-figure.vue?vue&type=script&lang=ts&"
import style0 from "./email-client-figure.vue?vue&type=style&index=0&id=4d5847c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5847c0",
  null
  
)

export default component.exports